const crisisMessageBtn = window.document.querySelectorAll('.js-crisis-toggle');
function crisisMessageEvent(event) {
  const headingEl = event.target;
  const headingText = headingEl.textContent;

  const closeHide = headingEl.getAttribute('data-close-hide');

  let showCloseButton = true;

  if (!Number.isNaN(parseInt(closeHide, 10))) {
    showCloseButton = false;
  }

  const targetEl = event.target.getAttribute('data-element');
  const messageEl = window.document.getElementById(targetEl);

  const nextText = messageEl.textContent;

  const veil = document.createElement('div');
  veil.classList.add('crisis-message__veil');

  const windowWrapEl = document.createElement('div');
  windowWrapEl.classList.add('crisis-message__wrapping');
  veil.appendChild(windowWrapEl);

  const windowHeadingEl = document.createElement('h2');
  windowHeadingEl.classList.add('crisis-message__headline');
  const titleTextNode = document.createTextNode(headingText);
  windowHeadingEl.appendChild(titleTextNode);
  windowWrapEl.appendChild(windowHeadingEl);

  const windowMessageEl = document.createElement('p');
  windowMessageEl.classList.add('crisis-message__information');
  const messageTextNode = document.createTextNode(nextText);
  windowMessageEl.appendChild(messageTextNode);
  windowWrapEl.appendChild(windowMessageEl);

  if (showCloseButton === true) {
    const windowCloseEl = document.createElement('button');
    windowCloseEl.classList.add('crisis-message__exit');
    windowCloseEl.addEventListener('click', () => {
      veil.classList.remove('appear');
      setTimeout(() => veil.remove(), 500);
    });
    windowWrapEl.appendChild(windowCloseEl);
  }

  const bodyEl = document.getElementsByTagName('body')[0];
  bodyEl.appendChild(veil);
  setTimeout(() => veil.classList.add('appear'), 10);
}

if (crisisMessageBtn) {
  crisisMessageBtn.forEach((item) => {
    item.addEventListener('click', (event) => {
      crisisMessageEvent(event);
    });
  });

  crisisMessageBtn.forEach((item) => {
    item.addEventListener('touchstart', (event) => {
      crisisMessageEvent(event);
    });
  });
}
